import Swiper, { A11y, Autoplay, EffectFade, Navigation, Pagination } from 'swiper'

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

const body  = document.querySelector('body');
const home = body.classList.contains('home');
const alu = document.querySelector('.alu .swiper-container');
const actu = document.querySelector('.acag .swiper-container');

if (home) {
    if (alu) {
        var state = document.querySelector('.alu-navigation__item--mode');
        var nbSlides = document.querySelectorAll('.alu .swiper-container .swiper-slide').length;
        var dataSlideAuto = document.querySelector('.alu .swiper-container').getAttribute('data-slide_auto');
        var dataSlideSpeed = document.querySelector('.alu .swiper-container').getAttribute('data-slide_speed');
        dataSlideSpeed = dataSlideSpeed + '000';


        var aluConfig = {
            slidesPerView: 1,
            centeredSlides: true,
            speed: 700,
            loop: true,
            autoHeight: true,

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges: true,
            },

            navigation: {
                prevEl: '.alu-navigation__item--prev',
                nextEl: '.alu-navigation__item--next',
            },
        };


        if (window.innerWidth > 640) {
            if (dataSlideAuto === '1') {
                aluConfig.autoplay = {
                    delay: dataSlideSpeed,
                    disableOnInteraction: false,
                }

                state.addEventListener('click', function () {
                    if (aluSwiper.autoplay.running) {
                        aluSwiper.autoplay.stop();

                        state.classList.remove('alu-navigation__item--pause')
                        state.classList.add('alu-navigation__item--play');
                    }

                    else {
                        aluSwiper.autoplay.start();

                        state.classList.remove('alu-navigation__item--play')
                        state.classList.add('alu-navigation__item--pause');
                    }
                });
            }
        }

        if (nbSlides > 1) {
            var aluSwiper = new Swiper('.alu .swiper-container', aluConfig);
        }
    }


    if (actu) {
        var actualiteSize = document.querySelectorAll('.acag .swiper-slide').length;

        var actualiteConfig = {
            speed: 700,
            effect: 'slide',
            grabCursor: 'true',

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges: true,
            },

            navigation: {
                prevEl: '.acag-navigation__item--prev',
                nextEl: '.acag-navigation__item--next',
            },

            
            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}',
            },

            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 20
                },

                620: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },

                960: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },

                1200: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                }
            }
        }

        let actualite = new Swiper('.acag .swiper-container', actualiteConfig);
    }
}